import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--resupri-radio-button"
export default class extends Controller {
  static targets = ["label"];
  connect() {}

  toggle(e) {
    e.stopPropagation();

    const targets = this.labelTargets;
    targets.forEach((target) => {
      target.classList.remove("checked");
    });
    e.currentTarget.classList.add("checked");
  }
}
